import React, { Component, useRef, useState, useEffect } from "react";
import { eval_inputs_basic_format, populate_WP_form_value } from '../js/validation';
import Footer from "./Footer.js";
import Header from "./Header";

const Ulster = () => {
    const [selectedOption, setSelectedOption] = useState('account');
    const [selectResOption, setSelectResOption] = useState(false);
    const [selectRegPayment, setSelectRegPayment] = useState(false);
    const [accountNumber, setAccountNumber] = useState('');
    const [sortCode, setSortCode] = useState('');
    const [cardNumber, setCardNumber] = useState('');
    const [reference, setRefNumber] = useState('');
    const [surname, setSurName] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [dateOfBirth, setDOB] = useState('');
    const [firstPayDay, setFirstPayDay] = useState('');
    const [firstPayMonth, setFirstPayMonth] = useState('');
    const [firstPayYear, setFirstPayYear] = useState('');
    const [frequency, setFrequency] = useState('');
    const [amount, setAmount] = useState('');
    const [errors, setValidationErrors] = useState({ selectedOption: "" });

    const [step, setStep] = useState(2);
    const [years, setYears] = useState([]);
    const wpApiUrl = process.env.REACT_APP_WORLDPAY_URL;
    console.log("World Pay url " + wpApiUrl);
    useEffect(() => {
        const generateYears = () => {
            const currentYear = new Date().getFullYear();
            return [currentYear, currentYear + 1, currentYear + 2];
        };
        setYears(generateYears());
    }, []);
    const handleNext = (e) => {
        setSelectedOption("account");
        e.preventDefault();
        var formErrors = eval_inputs_basic_format(selectedOption, selectResOption, selectRegPayment, accountNumber, sortCode, cardNumber, reference, surname, postalCode, dateOfBirth, firstPayDay, firstPayMonth, firstPayYear, frequency, amount);
        console.log(formErrors);
        setValidationErrors(formErrors);
        console.log('Erro after setting ' + setValidationErrors)
        if (formErrors === true) {
            populate_WP_form_value(selectedOption, selectResOption, selectRegPayment, amount, accountNumber, sortCode, cardNumber, reference, surname, postalCode, dateOfBirth, firstPayDay, firstPayMonth, firstPayYear, frequency);

            document.getElementById("Page_1").className = "hide";
            document.getElementById("Page_2").className = "curv-bl show";
            setStep(step + 1);
        }
        else {
            console.log("Form has error");
        }
    };
    const handlePrevious_1 = (e) => {
        console.log("Inside handle previous ");

        window.location.href ='https://www.ulsterbank.co.uk//current-accounts/manage-your-current-account/repayment_serviceulsterbank.html';
    };

    const resetState = () => {
        if (selectResOption == 'No') {
            setSurName('');
            setPostalCode('');
            setDOB('');
        }
        if (selectRegPayment == 'single') {
            setFirstPayDay('');
            setFirstPayMonth('');
            setFirstPayYear('');
            setFrequency('');
        }

    }

    const handleCancel_1 = (e) => {
        const shouldCancel = window.confirm("Warning : Cancelling the application will lose all the information you have keyed in. If you are happy to do this press ok");
        if (shouldCancel) {
            window.close();
        }
    };

    const handleClick = (e) => {
        console.log('Inside handleClick');
        setSelectedOption("account");
        setSelectResOption(null);


    };

    const handleRegClick = (e) => {
        console.log('Inside handleRegClick');
        setSelectResOption(e.target.value);


    };

    const handleRegPayment = (e) => {
        console.log('Inside handleRegPayment');
        setSelectRegPayment(e.target.value);


    };

    const handleAccNumber = (e) => {
        console.log('Inside handleAccNumber');
        setAccountNumber(e.target.value);

    };
    const handleSortode = (e) => {
        console.log('Inside handleSortode');
        setSortCode(e.target.value);

    };
    const handleRefNumber = (e) => {
        console.log('Inside handleRefNumber');
        setRefNumber(e.target.value);

    };
    const handleSurname = (e) => {
        console.log('Inside handleSurname');
        if (selectResOption === 'Yes') {
            setSurName(e.target.value);
        }
        else {
            setSurName('');
        }

    };
    const handlePostCode = (e) => {
        console.log('Inside handlePostCode');

        if (selectResOption === 'Yes') {
            setPostalCode(e.target.value);
        } else {
            setPostalCode('');
        }

    };
    const handleDOB = (e) => {
        console.log('Inside handleDOB');

        if (selectResOption === 'Yes') {
            setDOB(e.target.value);
        } else {
            setDOB('');
        }

    };
    const handlefirstPayDay = (e) => {
        console.log('Inside handlefirstPayDay');

        if (selectRegPayment === 'regular') {
            setFirstPayDay(e.target.value);
        }
        else {
            setFirstPayDay('');
        }
        sessionStorage.setItem('fpday', firstPayDay);
    };
    const handlefirstPayMonth = (e) => {
        console.log('Inside handlefirstPayMonth');

        if (selectRegPayment === 'regular') {
            setFirstPayMonth(e.target.value);
        }
        else {
            setFirstPayMonth('');
        }
        sessionStorage.setItem('fpmonth', firstPayMonth);
    };
    const handlefirstPayYear = (e) => {
        console.log('Inside handlefirstPayYear');
        if (selectRegPayment === 'regular') {
            setFirstPayYear(e.target.value);
        }
        else {
            setFirstPayYear('');
        }
        sessionStorage.setItem('fpyear', firstPayYear);
    };
    const handleFrequency = (e) => {
        console.log('Inside handleFrequency');
        if (selectRegPayment === 'regular') {
            setFrequency(e.target.value);
        }
        else {
            setFrequency('');
        }
        sessionStorage.setItem('frequency', frequency);
    };
    const handleAmount = (e) => {
        console.log('Inside handleAmount');
        setAmount(e.target.value);
        sessionStorage.setItem('amount', amount);
    };
    const goBack = (e) => {
        resetState();
        if (document.getElementById("Page_1") !== null) {
            document.getElementById("Page_1").className = "show";
            document.getElementById("Page_2").className = "curv-bl hide";
            setStep(step - 1);
        }
    }

    const openNewWindow = (e) => {
        e.preventDefault();
        const newWindow = window.open('/guideline', '_blank', 'noopener,noreferrer');
    };


    return (
        <html xmlns="http://www.w3.org/1999/xhtml" >
            <head>
                <meta http-equiv="Content-Type" content="text/html" />
                <meta http-equiv="expires" content="-1" />
                <meta http-equiv="pragma" content="no-cache" />
                <meta http-equiv="cache-control" content="no-cache" />
                <meta http-equiv="X-UA-Compatible" content="IE=11" />
                <meta name="robots" content="noindex,nofollow" />
                <meta name="keywords" />
                <title>
                    Ulster Bank Online Repayment Service - Account Details
                </title>
            </head>
            <div>
<Header/>
                <div id="wrapper" classNames="default_bg">
                    {/* <!-- -- -- -- -- progress indictator -- -- -- -- --> */}
                    <div className="progress">
                        <div className="progress-main">
                            <div className="progress-btm">
                                <div className="prog-title">
                                    <img src="/images/Champion_Hamburger_24x24.png" width="17.72" height="17" alt="" title="" border="0"
                                        className="proghamburger" />
                                    <span className="progIndicatortitle">Pay by card</span>
                                </div>
                                <ul>
                                    <li className="completed">
                                        <span>
                                            <div><img src="images/Champion_Tick.png" width="8" height="15" alt="Section completed."
                                                style={{ marginTop: '5px' }} title="Section completed." border="0" hspace="3" /></div>
                                            Welcome to the Online Repayment Service
                                        </span>
                                    </li>
                                    <li className={step === 2 ? "current" : step > 2 ? 'completed' : ''}>
                                        <span>
                                            <div><img src="images/Champion_Tick.png" width="8" height="15"
                                                alt="This is the current section." style={{ marginTop: '0px' }} title="This is the current section." border="0"
                                                hspace="3" /></div>
                                            Account details
                                        </span>
                                    </li>
                                    <li className={step === 3 ? "current" : step > 3 ? 'completed' : ''}>
                                        <span>
                                            <div></div>
                                            Payment summary
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            <div></div>
                                            Make payment
                                        </span>
                                    </li>
                                </ul>
                                <div className="clear"></div>
                            </div>
                        </div>
                    </div>

                    <div id="content">

                        {/* <!-- -- -- -- -- application title -- -- -- -- --> */}
                        <p className="app-title">Online Repayment Service</p>
                        <div className="pod">
                            <div className="pod-top">
                                <hr />
                            </div>
                            <div className="pod-btm">
                                <div id="Page_1" className="curv-bl">
                                    {/* <!-- Start Page 1 --> */}
                                    <form name="Form_1" >
                                        <h1 id="PageTitle1_hdrPageTitle" style={{ color: 'rgb(66, 20, 95' }}>Account Details</h1>

                                        <div>
                                            <p style={{ marginLeft: '10px'}}>Please enter details for the account to which you wish to make a payment.
                                                Required fields are indicated with a <span className="mand">*</span>.</p>
                                            <p style={{ marginLeft: '10px', marginBottom: '30px' }}>
                                                Your Sort Code & Account Number can usually be found in the headings of the letters we send
                                                you, Bank Statements and on any Cheque book that you may have for your account.
                                            </p>
                                        </div>
                                        <ul>
                                            <li style = {{marginTop : '-30px'}}>
                                                <div class="errorli" id="accountCheck_divRVError_0">Warning. This form cannot be submitted for
                                                    the following reasons: Please select the type of account to which you wish to make a
                                                    payment: is a mandatory field</div>
                                                <div className="errorli" id="accountCheck_divRVError_1" style = {{marginTop : '40px'}}>Warning. This form cannot be submitted for the following reasons:</div><br />

                                                <div id="accountCheck_pnlRVInput" className="hide vertradiofields">
                                                    <span id="accountCheck_rblRBs"><span
                                                        title="Please select the type of account to which you wish to make a payment - Current accounts and loans "><input
                                                            id="accountCheck_rblRBs_0" checked type="radio" name="accountCheck$rblRBs"
                                                            value="account" /><label style={{ width: '300px' }}
                                                                htmlFor="accountCheck_rblRBs_0">Current accounts and loans and Mortgages </label></span><br /><span
                                                                    title="Please select the type of account to which you wish to make a payment - Credit card/Virtual card"><input
                                                                id="accountCheck_rblRBs_1" type="radio" name="accountCheck$rblRBs" value="card"
                                                                /><label htmlFor="accountCheck_rblRBs_1">Credit
                                                                    card/Virtual card</label></span></span>

                                                </div>
                                            </li>
                                            <noscript>
                                                <li>
                                                    Depending on what has been selected above, please complete the relevant details below:
                                                </li>
                                            </noscript>

                                            <div><li>
                                                <div className="errorli" id="accNum_lblError"></div>
                                                <label htmlFor="accNum_txtNWBAccNum" id="accNum_lblNWBAccNum" className="stdlabel">Account
                                                    Number<span class="mand"> *</span></label>
                                                <div className="icons">
                                                </div>
                                                <input name="accNum$txtNWBAccNum" type="text" maxLength="8" size="8" id="accNum_txtNWBAccNum"
                                                    title="Account Number" onChange={(e) => handleAccNumber(e)} value={accountNumber} className="text" />
                                            </li><li id="hideli5">
                                                    <div className="errorli" id="sortCode_lblError"></div>
                                                    <label htmlFor="sortCode_txtNWBSortcode" id="sortCode_lblNWBSortcode" className="stdlabel">Sort
                                                        Code<span class="mand"> *</span></label>
                                                    <div className="icons">
                                                    </div>
                                                    <input name="sortCode$txtNWBSortcode" type="text" maxLength="6" size="6"
                                                        id="sortCode_txtNWBSortcode" title="Sort Code" onChange={(e) => handleSortode(e)} value={sortCode} className="text" />
                                                </li>
                                                <li>
                                                    <noscript>If you have chosen 'Bank account' for the account to which you wish to make a
                                                        payment, </noscript>
                                                    You may have a reference number. This is a set of up to 11 numbers which may be found in our
                                                    letters.<br />
                                                </li>
                                                <li>
                                                    <div className="errorli" id="refNumber_lblError">Reference Number: invalid data entered.</div>
                                                    <label htmlFor="refNumber_txtStdTextbox" id="refNumber_lblStdTextbox" className="stdlabel">Reference
                                                        Number</label>
                                                    <div className="icons">
                                                    </div>
                                                    <input name="refNumber$txtStdTextbox" type="text" maxLength="11" id="refNumber_txtStdTextbox"
                                                        title="Reference Number" onChange={(e) => handleRefNumber(e)} value={reference} className="text" size="11" />
                                                </li>
                                            </div>

                                            <div>
                                                <li id="hideli15">
                                                    <div class="errorli" id="resCheck_divRVError">Please can you confirm this account is
                                                        registered to a UK address: is a mandatory field</div>
                                                    <div id="resCheck_divRVLabel" className="radiolabel">Please can you confirm this account is
                                                        registered to a UK address?<span className="mand"> *</span></div>
                                                    <div className="icons">
                                                    </div>
                                                    <div id="resCheck_pnlRVInput" className="vertradiofields">
                                                        <span id="resCheck_rblRBs"><span
                                                            title="Please can you confirm this account is registered to a UK address? - Yes "><input
                                                                id="resCheck_rblRBs_0" type="radio" name="resCheck$rblRBs" value="Yes"
                                                                onChange={e => handleRegClick(e)} /><label htmlFor="resCheck_rblRBs_0">Yes
                                                            </label></span><br /><span
                                                                title="Please can you confirm this account is registered to a UK address? - No"><input
                                                                    id="resCheck_rblRBs_1" type="radio" name="resCheck$rblRBs" value="No"
                                                                    onChange={e => handleRegClick(e)} /><label
                                                                        htmlFor="resCheck_rblRBs_1">No</label></span></span>
                                                    </div>
                                                </li>
                                                {selectResOption === 'Yes' && (
                                                    <><li id="hideli11">
                                                        <div className="errorli" id="surName_txtStdError"></div>
                                                        <label htmlFor="surName_txtStdTextbox" id="surName_lblStdTextbox" className="stdlabel">Surname<span
                                                            className="mand"> *</span></label>
                                                        <div classNamess="icons">
                                                        </div>
                                                        <input name="surName$txtStdTextbox" type="text" maxLength="20" id="surName_txtStdTextbox"
                                                            style={{ marginLeft: '0px' }} title="Surname" classNamess="text" size="25" pattern="[A-Za-z]/" onChange={e => handleSurname(e)} value={surname} />
                                                    </li><li id="hideli12">
                                                            <div className="errorli" id="postCode_txtStdError"></div>
                                                            <label htmlFor="postCode_txtPostcode" id="postCode_lblPostcode" className="stdlabel">Postal Code<span
                                                                className="mand"> *</span></label>
                                                            <div className="icons">
                                                            </div>
                                                            <input name="postCode$txtPostcode" type="text" maxLength="8" id="postCode_txtPostcode"
                                                                title="Postal Code" className="text" size="8" onChange={e => handlePostCode(e)} value={postalCode} />
                                                        </li><li id="hideli13">
                                                            <div className="errorli" id="dateOfBirth_txtError"></div>
                                                            <label htmlFor="dateOfBirth_txtStdTextbox" id="dateOfBirth_lblStdTextbox" className="stdlabel">Date
                                                                of Birth (YYYY-MM-DD)<span className="mand"> *</span></label>
                                                            <div className="icons">
                                                            </div>
                                                            <input name="dateOfBirth$txtStdTextbox" type="text" maxLength="10"
                                                                id="dateOfBirth_txtStdTextbox" title="Date of Birth (YYYY-MM-DD)" className="text"
                                                                size="10" onChange={e => handleDOB(e)} value={dateOfBirth} />
                                                        </li><li id="hideli14">
                                                            <a href="/guideline" onClick={openNewWindow}>Click here for guidelines</a>
                                                        </li></>
                                                )}
                                            </div>


                                            <li>
                                                <div className="errorli" id="paymentOptions_pnlRVError">Please choose from one of the following
                                                    payment options: is a mandatory field</div>
                                                <div id="paymentOptions_divRVLabel" className="radiolabel">Please choose from one of the
                                                    following payment options<span className="mand"> *</span></div>
                                                <div className="icons">
                                                </div>
                                                <div id="paymentOptions_pnlRVInput" className="vertradiofields">
                                                    <span id="paymentOptions_rblRBs"><span
                                                        title="Please choose from one of the following payment  options - One off payment"><input
                                                            id="paymentOptions_rblRBs_0" type="radio" name="paymentOptions$rblRBs"
                                                            value="single" onChange={e => handleRegPayment(e)} /><label
                                                                htmlFor="paymentOptions_rblRBs_0">Single payment</label></span><br /><span
                                                                    title="Please choose from one of the following payment  options - Regular payments"><input
                                                                id="paymentOptions_rblRBs_1" type="radio" name="paymentOptions$rblRBs"
                                                                value="regular" onChange={e => handleRegPayment(e)} /><label
                                                                    htmlFor="paymentOptions_rblRBs_1">Regular payments</label></span></span>
                                                </div>
                                            </li>
                                            {selectRegPayment === 'regular' && (
                                                <div><li id="hideli1">
                                                    To make regular payments we also need the following information:
                                                </li><li id="hideli2">
                                                        <div className="datefields">
                                                            <div className="errorli" id="paymentOptions_DateError_01">First payment date: is a mandatory field</div>
                                                            <div className="errorli" id="paymentOptions_DateError_00">First payment date: please complete all fields</div>
                                                            <span id="paymentDate_lblDate" className="stdlabel">First payment date</span>
                                                            <div className="icons">
                                                            </div>
                                                            <label htmlFor="paymentDate_lstDay" id="paymentDate_lblDay" className="hidden">First payment date
                                                                - Day</label>
                                                            <select size="1" name="paymentDate$lstDay" id="paymentDate_lstDay" onChange={e => handlefirstPayDay(e)} value={firstPayDay}>
                                                                <option value="">-- Day --</option>
                                                                <option value="01">01</option>
                                                                <option value="02">02</option>
                                                                <option value="03">03</option>
                                                                <option value="04">04</option>
                                                                <option value="05">05</option>
                                                                <option value="06">06</option>
                                                                <option value="07">07</option>
                                                                <option value="08">08</option>
                                                                <option value="09">09</option>
                                                                <option value="10">10</option>
                                                                <option value="11">11</option>
                                                                <option value="12">12</option>
                                                                <option value="13">13</option>
                                                                <option value="14">14</option>
                                                                <option value="15">15</option>
                                                                <option value="16">16</option>
                                                                <option value="17">17</option>
                                                                <option value="18">18</option>
                                                                <option value="19">19</option>
                                                                <option value="20">20</option>
                                                                <option value="21">21</option>
                                                                <option value="22">22</option>
                                                                <option value="23">23</option>
                                                                <option value="24">24</option>
                                                                <option value="25">25</option>
                                                                <option value="26">26</option>
                                                                <option value="27">27</option>
                                                                <option value="28">28</option>
                                                                <option value="29">29</option>
                                                                <option value="30">30</option>
                                                                <option value="31">31</option>
                                                            </select>
                                                            <label htmlFor="paymentDate_lstMonth" id="paymentDate_lblMonth" className="hidden">First payment
                                                                date - Month</label>
                                                            <select size="1" name="paymentDate$lstMonth" id="paymentDate_lstMonth" onChange={e => handlefirstPayMonth(e)} value={firstPayMonth}>
                                                                <option value="">-- Month --</option>
                                                                <option value="01">January</option>
                                                                <option value="02">February</option>
                                                                <option value="03">March</option>
                                                                <option value="04">April</option>
                                                                <option value="05">May</option>
                                                                <option value="06">June</option>
                                                                <option value="07">July</option>
                                                                <option value="08">August</option>
                                                                <option value="09">September</option>
                                                                <option value="10">October</option>
                                                                <option value="11">November</option>
                                                                <option value="12">December</option>
                                                            </select>
                                                            <label htmlFor="paymentDate_lstYear" id="paymentDate_lblYear" className="hidden">First payment
                                                                date - Year</label>
                                                            <select size="1" name="paymentDate$lstYear" id="paymentDate_lstYear" onChange={e => handlefirstPayYear(e)} value={firstPayYear}>
                                                                <option value="">-- Year --</option>
                                                                {years.map((year) => (
                                                                    <option key={year} value={year}>{year}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </li><li id="hideli3">
                                                        <div className="errorli" id="frequency_lblError"></div>
                                                        <label htmlFor="frequency_lstDropdown" id="frequency_lblDropdown"
                                                            className="stdlabel">Frequency</label>
                                                        <div className="icons">
                                                        </div>
                                                        <select size="1" name="frequency$lstDropdown" id="frequency_lstDropdown" title="Frequency" onChange={e => handleFrequency(e)}>
                                                            <option value="">Please Select</option>
                                                            <option value="1">Daily</option>
                                                            <option value="2">Weekly</option>
                                                            <option value="3">Monthly</option>
                                                            <option value="4">Yearly</option>
                                                        </select>
                                                    </li></div>
                                            )}
                                            <li >
                                                Please enter the amount you wish to pay.
                                            </li>
                                            <li>
                                                <div className="errorli" id="amount1_txtStdError"></div>
                                                <label htmlFor="amount1_txtStdTextbox" id="amount1_lblStdTextbox" className="stdlabel">Amount
                                                    (£)<span className="mand"> *</span></label>

                                                <div className="icons">
                                                </div>
                                                <input name="amount1$txtStdTextbox" type="text" maxLength="9" id="amount1_txtStdTextbox"
                                                    title="Amount (£)" className="text" size="9" onChange={e => handleAmount(e)} />
                                            </li>
                                            <li>
                                                {/* <div className="hr"></div> */}
                                            </li>
                                        </ul>
                                        <div className="spacer"><br className="ff" /></div>
                                        <script language="javascript" type="text/javascript">
                                            checkRadio();

                                        </script>
                                        <div className="buttons">
                                            <div className="btnbg">
                                                <div className="t">
                                                    <div className="r">
                                                        <div className="b">
                                                            <div className="l">
                                                                <div className="btntl">
                                                                    <div className="btntr">
                                                                        <div className="btnbr">
                                                                            <div className="btnbl">
                                                                                <input type="button" name="btnPrev_1" value=" Back "
                                                                                    id="btnPrev_1" title="Previous page" onClick={e => handlePrevious_1(e)}
                                                                                    className="button-left back-arrow" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="btnbg">
                                                <div className="t">
                                                    <div className="r">
                                                        <div className="b">
                                                            <div className="l">
                                                                <div className="btntl">
                                                                    <div className="btntr">
                                                                        <div className="btnbr">
                                                                            <div className="btnbl">
                                                                                <input type="button"
                                                                                    name="direction" value="Cancel" id="S_CANCEL" title="Cancel the application - Warning: this will lose any data you have keyed in."
                                                                                    className="button-right" onClick={e => handleCancel_1(e)} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="btnbg">
                                                <div className="t">
                                                    <div className="r">
                                                        <div className="b">
                                                            <div className="l">
                                                                <div className="btntl">
                                                                    <div className="btntr">
                                                                        <div className="btnbr">
                                                                            <div className="btnbl">
                                                                                <input type="submit"
                                                                                    name="btnNext_1" value=" Next " id="btnNext_1" title="Next page" onClick={(e) => handleNext(e)}
                                                                                    className="button-right" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                </div>
                                <div id="Page_2" className="curv-bl hide">

                                    {/* <!-- Start Page 2 --> */}

                                    <div id="Page_2" className="curv-bl">

                                        <form id="Form_2" method="post" action={wpApiUrl} >
                                            <h1 id="PageTitle2_hdrPageTitle_2" style={{ marginTop: '0px', marginLeft: '20px' }}>Payment summary</h1>
                                            <ul style={{ marginLeft: '10px' }}>
                                                <li>
                                                    <input name="cartId" type="hidden" id="cartId" />
                                                    <input type="hidden" name="testMode" defaultValue={0} />
                                                    <input type="hidden" name="currency" defaultValue="GBP" />
                                                    <input type="hidden" name="lang" defaultValue="en" />
                                                    <input type="hidden" name="desc" value="Payment to Ulster Account" />
                                                    <input name="ac" type="hidden" id="ac" />
                                                    <input name="sc" type="hidden" id="sc" />
                                                    <input name="radio" type="hidden" id="radio" />
                                                    <input name="reference" type="hidden" id="reference" />
                                                    <input name="shopperAdditionalAccountNumber" type="hidden" id="shopperAdditionalAccountNumber" />
                                                    <input name="shopperAdditionalLastName" type="hidden" id="shopperAdditionalLastName" />
                                                    <input name="shopperAdditionalPostalCode" type="hidden" id="shopperAdditionalPostalCode" />
                                                    <input name="shopperAdditionalBirthDate" type="hidden" id="shopperAdditionalBirthDate" />
                                                    <input name="residentCheck" type="hidden" id="residentCheck" defaultValue="No" />
                                                </li>
                                                <li>
                                                    <p style={{ marginTop: '30px' }}>
                                                        Please confirm the following by clicking on 'submit' and you will be
                                                        transferred to WorldPay to make payment:
                                                    </p>
                                                </li>
                                                <li>
                                                    <div id="accNumConf" />
                                                    <div id="sortCodeConf" />
                                                    <div id="surNameConf" />
                                                    <div id="postCodeConf" />
                                                    <div id="dateOfBirthConf" />
                                                </li>
                                                <li>
                                                    {selectRegPayment === 'single' && (
                                                        <div id="singleFields" style={{ visibility: 'hidden' }}>
                                                            Amount to pay - <span id="amountConf" /><br />
                                                            <input type="hidden" name="instId" defaultValue={218356} />
                                                            <input type="hidden" name="accId1" defaultValue="ULSTERBANKLTM1" />
                                                            <input type="hidden" id="amount" name="amount" runat="server" />
                                                        </div>
                                                    )}
                                                    {selectRegPayment === 'regular' && (
                                                        <div id="regularFields" style={{ visibility: 'hidden' }}>

                                                            You have agreed to pay <span id="amount1Lbl"></span>{" "}
                                                            <span id="intervalUnitLbl"></span>, commencing on{" "}
                                                            <span id="startDateLbl"></span>
                                                            <br />
                                                            <input type="hidden" name="instId" defaultValue="218356" />
                                                            <input type="hidden" name="accId1" defaultValue="ULSTERBANKLTFUTUREPAY" />
                                                            <input type="hidden" name="futurePayType" defaultValue="regular" />
                                                            <input type="hidden" name="intervalMult" defaultValue={1} />
                                                            <input type="hidden" name="amountLimit" defaultValue={0} />
                                                            <input type="hidden" name="option" defaultValue={0} />
                                                            <input name="startDate" type="hidden" id="startDate" />
                                                            <input name="intervalUnit" type="hidden" id="intervalUnit" />
                                                            <input name="normalAmount" type="hidden" id="normalAmount" />
                                                        </div>
                                                    )}
                                                </li>
                                            </ul>
                                            <div className="buttons">
                                                <div className="placeHolder" style={{ marginTop: "69px" }}>

                                                    <input type="button" name="btnPre_1" value="Previous" id="A1" title="Previous page"
                                                        onClick={(e) => goBack(e)}
                                                        className="button-right" />
                                                </div>

                                                <div className="btnbg">
                                                    <div className="t">
                                                        <div className="r">
                                                            <div className="b">
                                                                <div className="l">
                                                                    <div className="btntl">
                                                                        <div className="btntr">
                                                                            <div className="btnbr">
                                                                                <div className="btnbl">
                                                                                    <input type="button" name="direction" id="S_CANCEL" value=" Cancel "
                                                                                        className="button-right no-arrow" title="Cancel the application - Warning: this will lose any data you have keyed in."
                                                                                        onClick={e => handleCancel_1(e)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="btnbg">
                                                    <div className="t">
                                                        <div className="r">
                                                            <div className="b">
                                                                <div className="l">
                                                                    <div className="btntl">
                                                                        <div className="btntr">
                                                                            <div className="btnbr">
                                                                                <div className="btnbl">
                                                                                    <input type="submit" value="Submit" tooltip="Submit" title="Submit" className="button-right arrow"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>



                                </div>
                                {/* <!-- end pod-btm --> */}
                            </div>
                            {/* <!-- end pod --> */}
                        </div>
                        {/* <!-- end content --> */}
                    </div>
                    <Footer />
                </div>
            </div>
        </html>


    );
};

export default Ulster;